import { Skeleton } from '@mui/material';
import { calculateLocatinVars } from '../../../libs/browser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import CommonPageTitle from '../../../components/CommonPageTitle';
import Context from '../../../provider';
import ErrorPage from '../../../pages/ErrorPage';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import React, { useContext, useEffect, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function PageDetail() {
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);
  const { init, dispatch, lang, me } = useContext(Context);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const notificationNotReadCount = useNotificationsCount();

  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: locationVars.join('/') });
      setData(page);
      setLoaded(true);
    } catch (error) {
      setPageNotFound(true);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) fetchData();
  }, [init]);

  // This page only allow logged in user
  useEffect(() => {
    // if (init) {
    //   if (!me) navigate(`${config.basename}login?redirect=${locationVars.join('/')}`);
    //   if (me?.status === 'new') navigate(`${config.basename}signup?redirect=${locationVars.join('/')}`);
    // }
  }, [init, me]);

  const getSectionStyle = (section) => {
    const style = {};
    if (section?.color_background_class) style.backgroundColor = section.color_background_class;
    if (section?.color_foreground_class) style.color = section.color_foreground_class;
    if (section?.background_texture) style.backgroundImage = `url(${section.background_texture})`;
    return style;
  };

  return (
    <>
      {pageNotFound && <ErrorPage type="notFound" />}
      {!pageNotFound && (
        <div className='web-page-detail'>
          <div className="full-width">
            <div className="section-max-container">
              {data?.sections && data.sections.length > 0 && data.sections[0].image[lang] && <div className='img-cont' style={{ backgroundImage: `url(${data.sections[0].image?.[lang]})` }} />}
              <div className='app-container'>
                {data?.title?.[lang] && <CommonPageTitle title={data?.title?.[lang]} />}
                {loaded && (data?.sections ??[]).map((section) => {
                  return (
                    <section className={ section.container_behavior ?? null } key={section.anchor} style={getSectionStyle(section)}>
                      <CommonDescription
                        title={section.hide_title ? null : section?.title?.[lang]}
                        data={section?.content?.[lang]}
                      />
                    </section>
                  );
                })}
                {!loaded && (
                  <>
                    <Skeleton animation="wave" variant="rounded" height={16} width='80%' className='skeleton' />
                    <Skeleton animation="wave" variant="rounded" height={16} width='100%' className='skeleton' />
                    <Skeleton animation="wave" variant="rounded" height={16} width='50%' className='skeleton' />
                  </>
                )}
              </div>
            </div>
            <div className="black-block full-width">
              <LogoFooterComponent />
            </div>
          </div>
        </div>
      )}
    </>
  );
}